import { Modal } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import clsx from "clsx";
import { closeGlobalModal } from "../../reducers/general/actions";
import useStyles from "./styles";
import MyButton from "../Button";

const SUCCESS_IMAGE = require("../../static/images/mfs/new_success_alert.png");
const ERROR_IMAGE = require("../../static/images/mfs/image_error_alert.png");

function GlobalModal(props) {
  const classes = useStyles();
  const { globalModal, t } = props;
  const renderImage = () => {
    if (globalModal.modalValue.modalType === "success") {
      return SUCCESS_IMAGE;
    }
    return ERROR_IMAGE;
  };

  const onCloseModal = () => {
    props.closeGlobalModal();
    props.globalModal.modalValue.onClose();
  };

  function getWidthModal() {
    if (globalModal.modalValue.widthType === "medium") {
      return classes.middleWidth;
    }
    return null;
  }

  return (
    <Modal
      open={globalModal.isOpen}
      onClose={onCloseModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.rootContainer}
    >
      <div className={clsx(classes.ctnModal, getWidthModal())}>
        <div id="padding-content">
          <img src={renderImage()} id="banner-icon" alt="banner-icon" />
          {globalModal.modalValue.title ? (
            <span
              className={
                !!globalModal.modalValue.subtitle === false
                  ? classes.txtAloneTitle
                  : ""
              }
              id="title"
            >
              {globalModal.modalValue.title}
            </span>
          ) : null}
          {globalModal.modalValue.subtitle ? (
            <span id="desc">{globalModal.modalValue.subtitle}</span>
          ) : null}
        </div>
        <MyButton gradient onClick={onCloseModal} className={classes.btnClose}>
          {globalModal.modalValue.closeValue || t("close")}
        </MyButton>
      </div>
    </Modal>
  );
}

GlobalModal.propTypes = {
  globalModal: PropTypes.any.isRequired,
  closeGlobalModal: PropTypes.func,
  t: PropTypes.func.isRequired,
};

GlobalModal.defaultProps = {
  title: "",
  desc: "",
  closeGlobalModal: () => { },
};

const mapStateToProps = (state) => ({
  globalModal: state.generalReducer.globalModal,
  reducerTest: state.generalReducer,
});

const enhancer = compose(
  withTranslation(["myfitsociety"]),
  connect(mapStateToProps, { closeGlobalModal })
);

export default enhancer(GlobalModal);
